module.exports = __webpack_public_path__ + "img/客户预开户操作手册3432.3049cee3.png";